import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumnTemplate from "./AbstractPeriodColumnTemplate.js";
import YearToDateColumn from "../../reports/columns/YearToDateColumn.js";

/**
 * Year to date column template.
 */
export default class YearToDateColumnTemplate extends AbstractPeriodColumnTemplate {
	_instanceClass() {
		return YearToDateColumn;
	}

	static getLabel() {
		return _("Year to date");
	}

	static getType() {
		return "YearToDateColumnTemplate";
	}
}
